import '@/assets/main.scss'

import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import App from './App.vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'
import * as Sentry from "@sentry/vue";

const myCustomLightTheme = {
    dark: false,
    colors: {
        background: '#FFF',
        surface: '#FFF',
        primary: '#003822',
        secondary: '#FB769B',
    },
}

const vuetify = createVuetify({
    components: { VDateInput, ...components },
    directives,
    theme: {
        defaultTheme: 'myCustomLightTheme',
        themes: {
            myCustomLightTheme,
        }
    },
    defaults: {
        VRadioGroup:    { color: 'primary'},
        VCheckbox:      { color: 'primary'},
        VTextField:     { color: 'primary', bgColor: 'white', flat: true, variant: 'solo-filled', rounded: 'lg' },
        VTextarea:      { color: 'primary', bgColor: 'white', flat: true, variant: 'solo-filled', rounded: 'lg' },
        VSelect:        { color: 'primary', bgColor: 'white', flat: true, variant: 'solo-filled', rounded: 'lg'  },
        VDateInput:     { color: 'primary', bgColor: 'white', flat: true, variant: 'solo-filled', rounded: 'lg'  },
        VAutocomplete:  { color: 'primary', bgColor: 'white', flat: true, variant: 'solo-filled', rounded: 'lg'  },
    },
    locale: {
        locale: 'en-AU',
    },
    date: {
        local: {
            en: 'en-AU',
        }
    }
})


const app = createApp(App);
Sentry.init({
    app,
    // Preserve the collection defaults used before Sentry 11.
    dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
            request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
            response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        },
        httpBodies: [],
        urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        genAI: { inputs: false, outputs: false },
        databaseQueryData: false,
        graphQL: { document: false, variables: false },
    },
    dsn: "https://0376e23ba0e8269234a23c0b1df73728@o4509171701841920.ingest.us.sentry.io/4509171704201216",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
    })],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
});

app.use(vuetify)

// Day js
dayjs.extend(customParseFormat)
app.provide('dayJS', dayjs)

app.mount('#app');


